Edit / Create new Diagnosis Information
<div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div 
        class="modal-header no-border"
      >
        <h5 class="modal-title text-color" id="exampleModalCenterTitle">{{ action }} {{ category | titlecase }} Info</h5>
        <button 
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeEditDiagnosisModal()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col">
          <form *ngIf="diagnosisInformation" (submit)="updateDiagnosis(updateDiagnosisForm.value)" #updateDiagnosisForm="ngForm"
            class="px-2 py-2">
            <div class="form-group">
              <label for="diagnosisName">{{ category | titlecase }} Name</label>
              <input type="text" class="form-control change-input-field" placeholder="name of diagnosis" name="name"
                #name="ngModel" [(ngModel)]="diagnosisInformation.name" value="{{ diagnosisInformation.name }}" minlength="3" />
            </div>
            <div class="form-group">
              <label for="cause">Cause</label>
              <input type="text" class="form-control change-input-field" placeholder="cause" name="cause" #cause="ngModel"
              [(ngModel)]="diagnosisInformation.cause" value="{{ diagnosisInformation.cause }}"  />
            </div>
            <div class="form-group">
              <label for="crop">Crop</label>
              <input type="text" class="form-control change-input-field" placeholder="crop" name="crop" #crop="ngModel"
              [(ngModel)]="diagnosisInformation.crop" value="{{ diagnosisInformation.crop }}" />
            </div>
            <div class="form-group">
              <label for="control">Prevention and Control</label>
              <quill-editor
                name="control"
                #control="ngModel"
                [(ngModel)]="diagnosisInformation.control"
                [modules]="quillConfig"
                (onEditorChanged)="clearErrorMessage(description)"
              >
              </quill-editor>
              <!-- <textarea type="text" class="form-control change-input-field" placeholder="control" name="control"
                #control="ngModel" [(ngModel)]="diagnosisInformation.control" value="{{ diagnosisInformation.control }}" minlength="3"></textarea> -->
            </div>
            <div class="form-group">
              <label for="explanation">Effects</label>
              <quill-editor
                name="explanation"
                #explanation="ngModel"
                [(ngModel)]="diagnosisInformation.explanation"
                [modules]="quillConfig"
                (onEditorChanged)="clearErrorMessage(description)"
              >
              </quill-editor>
              <!-- <textarea type="text" class="form-control change-input-field" placeholder="effects" name="explanation"
                #explanation="ngModel" [(ngModel)]="diagnosisInformation.explanation" value="{{ diagnosisInformation.explanation }}" ></textarea> -->
            </div>

            <div class="form-group" style="height: 400px;" *ngIf="countryName === 'Uganda'">
              <label for="input">Recommended Fertilizer/Pesticide</label>
              <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()">
              <select
                class="form-control form-control"
                id="diagnosisCrop"
                name="input"
                #input="ngModel"
                [(ngModel)]="diagnosisInformation.input"
                style="height: 90%;"
                multiple
              >
              <option selected
                *ngFor="let selected of selectedInfo" 
                value="{{selected.id}}">{{ selected.name }}</option>
                <option *ngFor="let inputItem of filterInputs" value="{{inputItem.id}}" class="crop">
                  {{ inputItem.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="input">Recommended Service</label>
              <!-- <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()"> -->
              <select
                class="form-control form-control"
                id="diagnosisCrop"
                name="service"
                #service="ngModel"
                [(ngModel)]="diagnosisInformation.service"
                multiple
              >
                <option *ngFor="let inputItem of parts" value="{{inputItem}}" class="crop">
                  {{ inputItem }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="photo">Image</label>
              <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files"
                (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
            </div>
            <div *ngIf="message">
              <div class="text-center mb-2">
                <i class="far fa-check-circle text-color h3"></i>
                <div class="mb-3"><h5>{{ status | titlecase }} !</h5></div>
                <div>{{ message }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-center align-item-center form-group">
              <button type="submit" class="submit-input-btn btn-success" *ngIf="status !== 'Success'">
                <span *ngIf="loadingModal" class="spinner-border spinner-border-md
                  text-white change-loading" role="status"></span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Save Info
                </span>
              </button>
              <button (click)="resetUpdateModal()" class="submit-input-btn btn-success" *ngIf="status === 'Success'">
                <span>
                  Close
                </span>
              </button>
            </div>
          </form>
          <ng-template #formSpinner>
            <div class="spinner d-flex">
              <span
                class="spinner-border spinner-border-md mx-auto"
                role="status"
              ></span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
